import React from 'react';

function StackPerspective3(props) {
	return (
		<svg height="30" width="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
	<g fill="#000">
		<path d="M5.43 20.71a1.25 1.25 0 0 1-0.63-0.17 2.89 2.89 0 0 1-1.46-2.51v-11.04c0-1.2 0.75-2.3 1.87-2.72l7.52-2.9a2.91 2.91 0 0 1 3.66 1.44 1.25 1.25 0 1 1-2.24 1.11 0.41 0.41 0 0 0-0.52-0.21l-7.52 2.89a0.42 0.42 0 0 0-0.27 0.39v11.04c0 0.2 0.13 0.31 0.22 0.35a1.25 1.25 0 0 1-0.63 2.33z" fill="#000"/>
		<path d="M10.44 24.89a1.25 1.25 0 0 1-0.63-0.17 2.89 2.89 0 0 1-1.46-2.52v-11.03c0-1.2 0.75-2.3 1.87-2.73l7.52-2.89a2.91 2.91 0 0 1 3.66 1.44 1.25 1.25 0 1 1-2.24 1.11c-0.09-0.17-0.3-0.3-0.52-0.21l-7.52 2.89a0.42 0.42 0 0 0-0.27 0.39v11.03c0 0.2 0.13 0.31 0.22 0.36a1.25 1.25 0 0 1-0.63 2.33z" fill="#000"/>
		<path d="M16.28 29.3a2.92 2.92 0 0 1-2.92-2.92v-11.04c0-1.2 0.75-2.3 1.87-2.73l7.52-2.89a2.92 2.92 0 0 1 3.97 2.73v11.04c0 1.2-0.75 2.3-1.87 2.72l-7.52 2.89a2.94 2.94 0 0 1-1.05 0.2z" fill="#000"/>
	</g>
</svg>
	);
};

export default StackPerspective3;